module.exports = require('./getJSON');



// WEBPACK FOOTER //
// ./lib/cache/get/json/index.js